import { defineMessages } from 'react-intl';

export const scope = 'app.components.globalNav.analyticsBetaNavLink';

export default defineMessages({
  analytics: {
    id: `${scope}.analyticsBeta`,
    defaultMessage: 'Analytics (beta)',
  },
});
